import { StyleSheet } from 'react-native';
import React, { useCallback, useEffect, useState } from 'react';
import { View } from '../../../../components/Themed';
import StaffForm from '../StaffForm';
import { FormType, UserRole } from '../../../../utils/enums';
import { PrivateStackScreenProps } from '../../../../app/navigation/types';
import { IStaff } from '../../../../models/IStaff';
import { useFirestore } from '../../../../app/providers/firestore';
import collections from '../../../../utils/collections';
import useToggle from '../../../../hooks/useToggle';
import { useAppSelector } from '../../../../hooks/hooks';
import { useFocusEffect } from '@react-navigation/native';
import { IconButton } from 'react-native-paper';
import Spacing from '../../../../res/constants/Spacing';
import useColorScheme from '../../../../hooks/useColorScheme';
import Styles from '../../../../res/constants/Styles';

const StaffDetailScreen = ({ navigation, route }: PrivateStackScreenProps<'StaffDetail'>) => {
  // #region MEMBERS
  const key: string | undefined = route.params.key;
  const formType: FormType = route.params.type;
  const archivedMode: boolean = route.params.archivedMode;
  // #endregion
  // #region STATES
  const [currentModel, setCurrentModel] = useState<IStaff | undefined>(undefined);
  const [confirmDialogVisibility, toggleConfirmDialog] = useToggle(false);
  const [loading, toggleLoading] = useToggle(false);
  // #endregion
  // #region CUSTOM HOOKS
  const { handleGetDocument, currentUser } = useFirestore();
  const currentSelectedUser = useAppSelector((state) => state.backOffice.selectedUser);
  const colorScheme = useColorScheme();
  const localTheme = Styles[colorScheme];
  // #endregion
  // #region FUNCTIONS
  const handleTargetUid = () => {
    if (currentUser) {
      if (currentUser.role === UserRole.BACKOFFICE) {
        if (currentSelectedUser) return currentSelectedUser.uid;
        else return currentUser.uid;
      } else {
        return currentUser.uid;
      }
    }
  };

  const handleClearObject = () => {
    setCurrentModel(undefined);
    navigation.navigate('EditStaff', { key, type: FormType.EDIT });
  };

  // #endregion
  // #region EFFECTS
  useFocusEffect(
    useCallback(() => {
      const uid = handleTargetUid(); // FIXME: Nuk eshte ok, duhet pare
      if (uid === undefined || key === undefined) return;

      toggleLoading(true);
      handleGetDocument(uid, key, collections.staff).then((value) => {
        setCurrentModel(value);
        toggleLoading(false);
      });
    }, [currentUser, currentSelectedUser, key])
  );

  useEffect(() => {
    navigation.setOptions({
      headerRight: () =>
        currentModel !== undefined && <IconButton icon={archivedMode ? 'delete-restore' : 'delete'} onPress={() => toggleConfirmDialog()} />,
    });
  }, [currentModel, archivedMode, key]);
  // #endregion

  return (
    <View style={[styles.root, { backgroundColor: localTheme.lightSelectedItem }]}>
      <StaffForm {...{ currentModel, formType, archivedMode, confirmDialogVisibility, toggleConfirmDialog }} handleClearObject={handleClearObject} />
    </View>
  );
};

export default StaffDetailScreen;

const styles = StyleSheet.create({
  root: {
    flex: 1,
    padding: Spacing.regular,
  },
});
